import DirectLessons from './Pages/DirectLessons';
import InformationPage from './Pages/InformationPage';
import SchedulePage from './Pages/SchedulePage';
import SubjectPage from './Pages/SubjectsPage';
import SummaryPage from './Pages/SummaryPage';

const flowroutes = [
  {
    title: 'Algemene gegevens',
    Component: InformationPage,
    url: '/Algemenegegevens',
    to: '/Schoolgegevens',
    index: 0,
  },
  {
    title: 'Schoolgegevens',
    Component: SubjectPage,
    url: '/Schoolgegevens',
    to: '/Beschikbaarheid',
    index: 1,
  },
  {
    title: 'Beschikbaarheid',
    Component: SchedulePage,
    url: '/Beschikbaarheid',
    to: '/DirectLessen',
    index: 2,
  },
  {
    title: 'Direct inplannen',
    Component: DirectLessons,
    url: '/DirectLessen',
    isTransfering: true,
    to: '/Samenvatting',
    index: 3,
  },
  {
    title: 'Samenvatting',
    Component: SummaryPage,
    url: '/Samenvatting',
  },
];

export default flowroutes;
